module.exports = __webpack_public_path__ + "media/images/pekarska-2D-final-953e84a2.svg";